import React, { useMemo, useState } from 'react';
import { Text } from '@common-fe/common-fe';

import VerifyBlock from '@/components/elements/VerifyBlock/VerifyBlock';
import { useDetectUrlHash } from '@/utils/hooks/useDetectUrlHash';

export enum SignInNotification {
  expressSetupSuccess = 'expressSetupSuccess',
}

const useSignInNotifications = () => {
  const [activeNotification, setNotification] = useState<SignInNotification | undefined>();

  useDetectUrlHash<SignInNotification>((notificationUrlHash) => {
    if (notificationUrlHash) {
      setNotification(notificationUrlHash);
    }
  });

  const activeNotificationElement = useMemo(() => {
    switch (activeNotification) {
    case SignInNotification.expressSetupSuccess: {
      return (
        <VerifyBlock key={SignInNotification.expressSetupSuccess} margin={{ bottom: 'spacing24' }}>
          <Text color="textOnColor" style={{ lineHeight: '20px' }}>
            Your account has been created!
          </Text>
          <Text color="textOnColor"  style={{ lineHeight: '20px' }}>
            Please login using your credentials.
          </Text>
        </VerifyBlock>
      );
    }
    default: {
      return null;
    }
    }
  }, [activeNotification]);

  return activeNotificationElement;
};

export default useSignInNotifications;
